// client/src/utils/pdfjs.js
import { GlobalWorkerOptions, getDocument } from "pdfjs-dist/legacy/build/pdf";
import pdfWorker from "pdfjs-dist/legacy/build/pdf.worker.min.js";

GlobalWorkerOptions.workerSrc = pdfWorker;

const API_BASE =
	process.env.REACT_APP_API_URL ||
	(process.env.NODE_ENV === "production" ? "/api" : "http://localhost:5000/api");

function resolvePdfUrl(url) {
	if (!url) return url;
	if (/^https?:\/\//i.test(url)) {
		return url;
	}
	try {
		return new URL(url, API_BASE).toString();
	} catch (err) {
		return url;
	}
}

export async function loadPdfDocument(url) {
	const token = localStorage.getItem("token");
	const resolvedUrl = resolvePdfUrl(url);
	const loadingTask = getDocument({
		url: resolvedUrl,
		httpHeaders: token ? { Authorization: `Bearer ${token}` } : undefined,
		withCredentials: false,
	});
	return loadingTask.promise;
}

export async function renderPdfPage(pdfDoc, pageIndex, scale) {
	const page = await pdfDoc.getPage(pageIndex + 1);
	const viewport = page.getViewport({ scale });
	const canvas = document.createElement("canvas");
	const context = canvas.getContext("2d");
	canvas.width = viewport.width;
	canvas.height = viewport.height;
	await page.render({ canvasContext: context, viewport }).promise;
	return { canvas, viewport };
}

export async function getPdfPageSize(pdfDoc, pageIndex) {
	const page = await pdfDoc.getPage(pageIndex + 1);
	const viewport = page.getViewport({ scale: 1 });
	return { width: viewport.width, height: viewport.height };
}
